import React, { useEffect, useState } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { fetchListItems } from '../../../../../hooks/useCrud';
import { fileUrl } from '../../../../../api/config';

interface UiPartenaire {
    id?: number;
    nom?: string;
    url?: string;
    icone?: string;
    logoFile?: File;
    createdAt?: string;
    updatedAt?: string;

}

export default function Partenaire() {

    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 4,
            slidesToSlide: 1
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2,
            slidesToSlide: 1
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            slidesToSlide: 1
        }
    };
    const [preview, setPreview] = useState<string | null>(null);

    const [partners, setPartenaire] = useState<UiPartenaire[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const fetchListPartenaire = async () => {
        setLoading(true);
        try {
            const res = await fetchListItems<UiPartenaire>('/fetch_partenaire_data');
            setPartenaire(res.data);

            // console.log(res);
        } finally {
            setLoading(false);
        }

    }

    useEffect(() => {
        fetchListPartenaire();
    }, []);




    return (
        <div className="section panel">
            <div className="section-outer panel py-4 md:py-6 lg:py-8 xl:py-10 bg-white dark:bg-gray-900">
                <div className="container max-w-5xl p-0 sm:px-2 lg:px-4 xl:px-0">
                    <div className="section-inner">
                        <div className="vstack gap-4 panel">

                            {/* HEADER */}
                            <div className="text-center mb-4">
                                <h2 className="h3 font-bold text-gray-900 dark:text-white">
                                    <i className="fas fa-handshake text-primary me-2"></i>
                                    Nos Partenaires Officiels
                                </h2>
                                <p className="fs-6 mt-1 text-gray-600 dark:text-gray-400">
                                    Ensemble, nous construisons l’avenir du basketball congolais.
                                </p>
                            </div>

                            {/* CAROUSEL */}
                            <Carousel
                                responsive={responsive}
                                infinite={true}
                                autoPlay={true}
                                autoPlaySpeed={2800}
                                keyBoardControl={true}
                                customTransition="all .6s ease"
                                transitionDuration={600}
                                containerClass="carousel-container"
                                removeArrowOnDeviceType={["tablet", "mobile"]}
                                itemClass="px-3"
                            >
                                {partners.map((partner, index) => (
                                    <div key={index} className="h-full">

                                        <a
                                            href={partner.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="
                                                block rounded-xl p-6 
                                                bg-white/90 dark:bg-gray-800/80 
                                                backdrop-blur-lg shadow-sm 
                                                hover:shadow-xl 
                                               
                                                transition-all duration-300 
                                                hover:-translate-y-1
                                            "
                                        >
                                            <div className="flex justify-center items-center h-32">
                                                <img
                                                    src={fileUrl + '/images/' + partner.icone!}
                                                    alt={partner.nom}
                                                    className="
                                                        h-16 w-auto mx-auto 
                                                        opacity-80 hover:opacity-100 
                                                        grayscale hover:grayscale-0 
                                                        transition-all duration-300 
                                                        hover:scale-105
                                                    "
                                                    style={{
                                                        maxWidth: '200px',
                                                        maxHeight: '160px',
                                                        objectFit: 'contain'
                                                    }}
                                                />
                                            </div>

                                          
                                        </a>

                                    </div>
                                ))}
                            </Carousel>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}
